<template>
    <b-form @submit.prevent class="lx-grid-search-form mr-2">
        <b-form-input v-model="inputValue" placeholder="Filter"></b-form-input>
    </b-form>
</template>

<script>
    import debounce from 'lodash/debounce';

    export default {
        name: 'GridSearch',
        data() {
            return {
                inputValue: '',
            };
        },
        methods: {
            doSearch(query) {
                this.$emit('search', query);
            },
        },
        watch: {
            inputValue: debounce(function(val) {
                this.doSearch(val.trim());
            }, 500),
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    @include media-breakpoint-down(xs) {
        .lx-grid-search-form {
            width: 100%;
        }
    }
</style>
